import React from 'react'
import { format } from 'date-fns'

import Table from '../../../../components/molecules/Table'

import { columnHelper, getCost } from './helpers'
import { useInvoice } from '../../../../providers/InvoiceProvider'
import useStyles from './styles'

const InvoiceSettings = () => {
  const { invoices, loaded } = useInvoice()

  const classes = useStyles()

  const columns = React.useMemo(() => {
    const numberColumn = columnHelper.accessor('number', {
      header: 'ID',
      cell: ({ row }) => (
        <div className={classes.number}>{row.original.number}</div>
      )
    })

    const dateColumn = columnHelper.accessor('created', {
      header: 'Date',
      cell: ({ row }) => (
        <div>{format(new Date(row.original.created), 'EEE, MMM d yyyy')}</div>
      )
    })

    const costColumn = columnHelper.accessor('total', {
      header: 'Amount',
      cell: ({ row }) => (
        <div className={classes.cost}>{getCost(row.original)}</div>
      )
    })

    const pdfColumn = columnHelper.accessor('link', {
      header: 'Invoice',
      cell: ({ row }) => (
        <div className={classes.pdf}>
          <a href={row.original.link}>
            <img src='/imgs/billing/file_format_pdf.png' alt='' />
          </a>
        </div>
      )
    })

    return [numberColumn, dateColumn, costColumn, pdfColumn]
  }, [classes])

  return (
    <Table
      data={invoices}
      columns={columns}
      loaded={loaded}
      message='No past invoices'
      hideCount
      disablePagination
    />
  )
}

export default InvoiceSettings
